import actions from '../actions';
import {connect} from 'react-redux';
import {getModalState} from '../selectors';
import {getFullLocale, getIsMobile, getSiteName} from '../../../selectors/system';

export function mapStateToProps(state) {
    const {
        error,
        inviteUrl,
        isModalOpen,
        loading,
        loginUrl
    } = getModalState(state);

    return {
        error,
        fullLocale: getFullLocale(state),
        inviteUrl,
        isMobile: getIsMobile(state),
        isOpen: isModalOpen,
        loading,
        loginUrl,
        siteName: getSiteName(state)
    };
}

export const mapDispatchToProps = {
    collaborate: actions.collaborate,
    invite: actions.invite,
    login: actions.login,
    reset: actions.reset
};

export function withCollaborateState(Component) {
    return connect(mapStateToProps, mapDispatchToProps)(Component);
}


// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/components/state.js